// components/PrivateRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import InactivityHandler from '../components/InactivityHandler';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');

  return token ? (<InactivityHandler>{children}</InactivityHandler>) : (<Navigate to="/login" replace />);
};

export default PrivateRoute;
